export default "__VITE_ASSET__BO60Gr_B__"